import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UserSelectComponent} from "./user-select.component";
import {MatSelectModule} from "@angular/material/select";
import {ReactiveFormsModule} from "@angular/forms";
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [UserSelectComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatTooltipModule
  ],
  exports: [UserSelectComponent]
})
export class UserSelectModule { }
